export default __webpack_public_path__ + "static/media/030-tiered skirt.89bbffd9.svg";